var m = require('mithril');
var Formula = require('excel-formula');

const {ABS, ACOS, ACOSH, ACOT, ACOTH, ADD, AGGREGATE, AND, ARABIC, ASIN, ASINH, ATAN, ATAN2, 
  ATANH, AVEDEV, AVERAGE, AVERAGEA, AVERAGEIF, AVERAGEIFS, BASE, BESSELI, BESSELJ, BESSELK, BESSELY, BETA, BIN2DEC, BIN2HEX, 
  BIN2OCT, BINOM, BITAND, BITLSHIFT, BITOR, BITRSHIFT, BITXOR, CEILING, CHISQ, COMBIN, COMBINA, COMPLEX, CONFIDENCE, CONVERT, 
  CORREL, COS, COSH, COT, COTH, COUNT, COUNTA, COUNTBLANK, COUNTIF, COUNTIFS, COUNTIN, COUNTUNIQUE, COVARIANCE, CSC, CSCH, DEC2BIN, 
  DEC2HEX, DEC2OCT, DECIMAL, DEGREES, DELTA, DEVSQ, DIVIDE, E, EQ, ERF, ERFC, EVEN, EXP, EXPON, F, FACT, FACTDOUBLE, FALSE, FISHER, 
  FISHERINV, FLOOR, FORECAST, FREQUENCY, GAMMA, GAMMALN, GAUSS, GCD, GEOMEAN, GESTEP, GROWTH, GT, GTE, HARMEAN, HEX2BIN, HEX2DEC, HEX2OCT, 
  HYPGEOM, IF, IFERROR, IFNA, IFS, IMABS, IMAGINARY, IMARGUMENT, IMCONJUGATE, IMCOS, IMCOSH, IMCOT, IMCSC, IMCSCH, IMDIV, IMEXP, IMLN, 
  IMLOG10, IMLOG2, IMPOWER, IMPRODUCT, IMREAL, IMSEC, IMSECH, IMSIN, IMSINH, IMSQRT, IMSUB, IMSUM, IMTAN, INT, INTERCEPT, ISO, KURT, LARGE, 
  LCM, LINEST, LN, LN10, LN2, LOG, LOG10, LOG10E, LOG2E, LOGEST, LOGNORM, LT, LTE, MAX, MAXA, MEDIAN, MIN, MINA, MINUS, MOD, MODE, MROUND, 
  MULTINOMIAL, MULTIPLY, NE, NEGBINOM, NORM, NOT, OCT2BIN, OCT2DEC, OCT2HEX, ODD, OR, PEARSON, PERCENTILE, PERCENTRANK, PERMUT, PERMUTATIONA, 
  PHI, PI, POISSON, POW, POWER, PROB, PRODUCT, QUARTILE, QUOTIENT, RADIANS, RAND, RANDBETWEEN, RANK, ROMAN, ROUND, ROUNDDOWN, ROUNDUP, ROW, 
  RSQ, SEC, SECH, SERIESSUM, SIGN, SIN, SINH, SKEW, SLOPE, SMALL, SQRT, SQRT1_2, SQRT2, SQRTPI, STANDARDIZE, STDEV, STDEVA, STDEVPA, STEYX, 
  SUBTOTAL, SUM, SUMIF, SUMIFS, SUMPRODUCT, SUMSQ, SUMX2MY2, SUMX2PY2, SUMXMY2, SWITCH, T, TAN, TANH, TREND, TRIMMEAN, TRUE, TRUNC, VAR, VARA, 
  VARPA, WEIBULL, XOR, Z} = require('@formulajs/formulajs');

var key = require('../libs/keybindings');
var modal = require('../layout/components/modal');
var loaders = require('../layout/components/loaders');
var buttonElement = require('../components/button');
var variableTd = require('../data/components/variableTd');
var heading = require('../components/heading');
var Model = require('../libs/Model');
var aggregateForm = Object.create(Model);
Object.assign(aggregateForm, require('../../../../models/data/aggregate'));
var variableForm = require('../data/components/variableModal');

var alphabet = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'];

function resetFormulaPreview(ctrl) {
  ctrl.formulaError = undefined;
  ctrl.formulaResult = undefined;
}

function getVariableIndex(variableRecord, fallbackIndex) {
  var index = variableRecord && variableRecord.index;
  index = Number(index);
  if (Number.isInteger(index) && index >= 0) {
    return index;
  }
  return fallbackIndex;
}

function hasVariableIndexes(variables) {
  return (variables || []).some(function (variableRecord, idx) {
    return getVariableIndex(variableRecord, idx) !== idx;
  });
}

function getFormulaVariableRecord(match, variables) {
  var index = alphabet.indexOf(match);
  if (hasVariableIndexes(variables)) {
    return (variables || []).find(function (variableRecord, idx) {
      return getVariableIndex(variableRecord, idx) === index;
    });
  }
  return variables[index];
}

function getVariableSymbol(variableRecord, fallbackIndex) {
  return alphabet[getVariableIndex(variableRecord, fallbackIndex)] || '';
}

function getAggregateSaveError(ctrl) {
  var func = ctrl.form.form && ctrl.form.form.func();
  if (func === 'subtraction' || func === 'subtractionABS') {
    var variables = ctrl.form.record.variables || [];
    if (variables.length < 2) {
      return 'Aggregate function "' + func + '" requires at least 2 variables.';
    }
  }
  return null;
}

var oninit = function () {
  var ctrl = this;
  var i=0

  ctrl.init = function () {
    if (m.route.param('key') && (m.route.param('key') !== 'new')) {
      loaders.requestWithLoader({
        method : 'GET',
        url: '/api/v1/aggregate/' + m.route.param('key'),
        loader: 'main'
      })
      .then(function (res) {
        ctrl.form.initForm.call(ctrl.form, res);
      });
    } else {
      ctrl.form.initForm.call(ctrl.form);
    }
    m.redraw();
  }
  ctrl.form = aggregateForm;
  ctrl.funcs = ['summation', 'subtraction', 'subtractionABS'];
  ctrl.formulaResult = undefined;

  ctrl.save = function () {
    var saveError = getAggregateSaveError(ctrl);
    if (saveError) {
      ctrl.form.errors = [saveError];
      m.redraw();
      return false;
    }

    return ctrl.form.save()
    .then(function (newAggregate) {
      if (typeof ctrl.form.record['@rid'] === 'undefined') {
        m.route.set('/aggregate/' + newAggregate['@rid'].slice(1));
      }
    })
  };

  ctrl.testFormula = function testFormula () {
    var rawFormula = ctrl.form.form.formula() || '';
    if (!rawFormula.trim()) {
      ctrl.formulaError = 'Formula is required.';
      ctrl.formulaResult = undefined;
      return false;
    }
    var variables = ctrl.form.record.variables || [];

    try {
      var formula = rawFormula.replace(/[a-z]/g, function (match) {
        var variableRecord = getFormulaVariableRecord(match, variables);
        if (!variableRecord || !variableRecord.in) {
          throw new Error('Formula references unknown variable "' + match + '".');
        }
        var value = Number(variableRecord.in.value);
        if (!Number.isFinite(value)) {
          throw new Error('Variable "' + match + '" must have a finite value.');
        }
        return ' ' + value + ' ';
      }).replace(/ /g, '')
      var result = eval(Formula.toJavaScript(formula));
      if (!Number.isFinite(Number(result))) {
        throw new Error('Formula result must be a finite number.');
      }
      result = Number(result);
      ctrl.formulaResult = result;
      ctrl.formulaError = undefined;
      return result;
    } catch (e) { 
      ctrl.formulaError = e.message;
      ctrl.formulaResult = undefined;
      return false;
    }
  }

  ctrl.handleFormulaKeydown = function handleFormulaKeydown (ev) {
    if (!ev || (ev.key !== 'Enter' && ev.keyCode !== 13)) {
      return true;
    }
    if (typeof ev.preventDefault === 'function') {
      ev.preventDefault();
    }
    if (typeof ev.stopPropagation === 'function') {
      ev.stopPropagation();
    }
    ctrl.testFormula();
    m.redraw();
    return false;
  }

  key('enter', 'aggregateEditor', ctrl.save);
  key('enter', 'formulaEditor', ctrl.testFormula);
  key.setScope('aggregateEditor');
  
  modal.on('closed', ctrl.init)

  ctrl.init();
};

var onremove = function () {
  modal.off('closed', this.init);
  key.setScope('home');
}

var view = function () {
  var ctrl=this
  if(!ctrl.form.form){
    return m('div')
  }
  return m('div.container', [
    m(heading, {
      label: ctrl.form.record['@rid'] ? 'Edit Aggregate' : 'New Aggregate', 
      helpIcon: true,
      helpFileName: 'aggregateEditor.md',
      helpModalTitle: 'Aggregate Editor Help',
      class: 'f-subheadline mb3 pb1'
    }),
    m('form', {role:'form'}, [
      ctrl.form.errorView.call(ctrl.form),
      m('div', {class:'form-group'}, [
        m('name', {for:'name-input'}, 'Name'),
        m('input.form-control', {
          id:'name-input', 
          type:'text', 
          oninput: function(ev){ctrl.form.form.name(ev.target.value)},
          value: ctrl.form.form.name(),
        })
      ]),
      m('div', {class:'form-group'}, [
        m('name', {for:'func-input'}, 'Function'),
        m('select.form-control', {
          id:'function-input', 
          //type:'text', 
          onchange: function(ev){
            ctrl.form.form.func(ev.target.value);
            ctrl.form.errors = [];
          },
          value: ctrl.form.form.func()
        }, 
          m('option', {value: 'formula'}, 'Formula'),
          ctrl.funcs.map(function (func) {
            return m('option', {value: func}, func)
          })
        ),
      ]),
      (function () {
        if (ctrl.form.form.func() === 'formula') {
          return m('div.form-group', [
            m('label', {for:'formula-input'}, 'Formula'),
            m('input.form-control', {
              id: 'formula-input',
              type: 'text',
              oninput: function(ev){
                ctrl.form.form.formula(ev.target.value);
                resetFormulaPreview(ctrl);
              },
              value: ctrl.form.form.formula(),
              onkeydown: ctrl.handleFormulaKeydown,
              onfocus: key.setScope.bind(null, 'formulaEditor'),
              onblur: key.setScope.bind(null, 'aggregateEditor')
            }),
            m('div.w-100.flex.justify-start.mt1', [
              m(buttonElement, {
                label: 'Test Formula',
                class: 'mt2 w-50 mr1',
                func: ctrl.testFormula
              }),
              (function () {
                if (ctrl.formulaError) {
                  return m('div.bw1.w-50.ba.mt2.red.tc.pt2', ctrl.formulaError);
                } else if (typeof ctrl.formulaResult !== 'undefined') {
                  return m('div.bw1.w-50.ba.mt2.blue.tc.pt2', ctrl.formulaResult)
                } else {
                  return m('div.bw1.w-50.ba.mt2')
                }
              })()
            ]),
          ]);
        }
      })(),
      m('div', {class:'form-group'}, [
        m(heading, {label: 'Variables', class: ' pb1 f2 pt2'}),
        m('table.w-100.f4.pt2.pb3', [
          m('thead', [
            m('tr', [
              m('th.tc.v-btm.bw1.ph2', [
                m('p.ma0.tc', 'Name')
              ]),
              m('th.tc.v-btm.bw1.ph2', [
                m('p.ma0.tc', 'Value')
              ]),
              m('th.tc.v-btm.bw1.ph2', [
                m('p.ma0.tc', 'Symbol')
              ]),
              m('th.tc.v-btm.bw1.ph2', [
                m('p.ma0.tc', 'Source Unit')
              ]),
              m('th.tc.v-btm.bw1.ph2', [
                m('p.ma0.tc', 'Unit Conversion')
              ]),
              m('th.tc.v-btm.bw1.ph2', [
                // m('p.ma0.tc', 'Edit')
              ])
            ])
          ]),
          m('tbody', [
            Array.prototype.map.call(ctrl.form.record.variables || [], function (point, idx) {
              return m('tr', [
                m('td.tc.bb-0.bl-0.b--dotted.bw1', point.name),
                m(variableTd, point),
                m('td.tc.bb-0.bl-0.b--dotted.bw1.blue', getVariableSymbol(point, idx)),
                m('td.tc.bb-0.bl-0.b--dotted.bw1.blue', point.unit || ''),
                m('td.tc.bb-0.bl-0.b--dotted.bw1.blue', point.unitConversion || ''),
                m('td.tc.br-0.bb-0.bl-0.b--dotted.bw1', [
                  m('div.flex.justify-center.items-center', [
                    m(buttonElement, {
                      class: 'mr2',
                      label: m('i.f4.ion-ios-compose-outline.blue'),
                      func: function () {
                      variableForm.editDialogue.call(variableForm, point);
                      }
                    }),
                    m(buttonElement, {
                      label: m('i.f4.ion-ios-trash.red'),
                      func: variableForm.deleteDialogue.bind(variableForm, point)
                    })
                  ])
                ])
              ])
            }),
            m('tr', [
              m('td.tc.bb-0.bl-0.b--dotted.bw1'),
              m('td.tc.bb-0.bl-0.b--dotted.bw1'),
              m('td.tc.bb-0.bl-0.b--dotted.bw1'),
              m('td.tc.bb-0.bl-0.b--dotted.bw1'),
              m('td.tc.bb-0.bl-0.b--dotted.bw1'),
              m('td.tc.br-0.bb-0.bl-0.b--dotted.bw1', [
                (function () {
                  if (ctrl.form.record['@rid']) {
                    return m('i.ion-plus.blue', {
                      onclick: variableForm.editDialogue.bind(variableForm, {out: ctrl.form.record['@rid']})
                    })
                  } else {
                    return '';
                  }
                })()
              ])
            ]),
            (function () {
              if (ctrl.form.record.point && ctrl.form.record.point['@rid']) {
                return  m('tr', [
                  m('td.tc.bb-0.bl-0.b--dotted.bw1', 'Result'),
                  m(variableTd, {in: ctrl.form.record.point}),
                  m('td.tc.bb-0.bl-0.b--dotted.bw1'),
                  m('td.tc.bb-0.bl-0.b--dotted.bw1'),
                  m('td.tc.bb-0.bl-0.b--dotted.bw1'),
                  m('td.tc.br-0.bb-0.bl-0.b--dotted.bw1')
                ]);
              }
            })()
          ])
        ])
      ]),
      m(buttonElement, {label:ctrl.form.record['@rid'] ? 'Save' : 'Save (Add Variable)', class: 'mt2',func: ctrl.save.bind()})
    ])
  ])
};

module.exports = {oninit, onremove, view};
